// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a164ec00f23a6b41b2d9","293":"ea38c4c047e6d3922844","518":"210d26a6fb20e7daef08","779":"6c3ef038378e0e7b600a"}[chunkId] + ".js";
};